// components/ImportResumeComponent.tsx
"use client";
import { useDispatch } from "react-redux";
import { getHasUsedAppBefore } from "lib/redux/local-storage";
import { toggleImportComponent } from "lib/redux/settingsSlice";
import { ResumeDropzone } from "components/ResumeDropzone";
import { useState, useEffect } from "react";
import Link from "next/link";

export const ImportResumeComponent = () => {
  const [hasUsedAppBefore, setHasUsedAppBefore] = useState(false);
  const [hasAddedResume, setHasAddedResume] = useState(false);
  const dispatch = useDispatch();

  const toggleImportComponentState = () => {
    dispatch(toggleImportComponent()); // Dispatching the action to toggle the state
  };

  const onFileUrlChange = (fileUrl: string) => {
    setHasAddedResume(Boolean(fileUrl));
  };

  useEffect(() => {
    setHasUsedAppBefore(getHasUsedAppBefore());
  }, []);

  return (
    <div className="relative mx-auto w-[70vw] rounded-md border border-gray-200 bg-white p-5 text-center shadow-md md:w-[50vw] lg:max-w-3xl lg:p-10">
      <div
        className="absolute right-1 top-1 w-6 cursor-pointer"
        onClick={toggleImportComponentState}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={1.5}
          stroke="currentColor"
          className="size-6"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M6 18 18 6M6 6l12 12"
          />
        </svg>
      </div>
      {!hasUsedAppBefore ? (
        <>
          <h1 className="text-lg font-semibold text-gray-900">
            Import data from an existing resume
          </h1>
          <ResumeDropzone onFileUrlChange={onFileUrlChange} className="mt-5" />
          {!hasAddedResume && (
            <>
              <OrDivider />
              <SectionWithHeadingAndCreateButton
                heading="Don't have a resume yet?"
                buttonText="Create from scratch"
              />
            </>
          )}
        </>
      ) : (
        <>
          {/* {!hasAddedResume && (
            <>
              <SectionWithHeadingAndCreateButton
                heading="You have data saved in browser from prior session"
                buttonText="Continue where I left off"
              />
              <OrDivider />
            </>
          )}
          <h1 className="font-semibold text-gray-900">
            Override data with a new resume
          </h1> */}
          <ResumeDropzone onFileUrlChange={onFileUrlChange} />
        </>
      )}
    </div>
  );
};

const OrDivider = () => (
  <div className="mx-[-2.5rem] flex items-center pb-6 pt-8" aria-hidden="true">
    <div className="flex-grow border-t border-gray-200" />
    <span className="mx-2 mt-[-2px] flex-shrink text-lg text-gray-400">or</span>
    <div className="flex-grow border-t border-gray-200" />
  </div>
);

const SectionWithHeadingAndCreateButton = ({
  heading,
  buttonText,
}: {
  heading: string;
  buttonText: string;
}) => {
  return (
    <>
      <p className="font-semibold text-gray-900">{heading}</p>
      <div className="mt-5">
        <Link
          href="/resume-builder"
          className="outline-theme-blue rounded-full bg-sky-500 px-6 pb-2 pt-1.5 text-base font-semibold text-white"
        >
          {buttonText}
        </Link>
      </div>
    </>
  );
};
